class DataRenderToImage {
  partName;
  variantName
  imgView1;
  imgView2;
  imgView3;
  order;
  partShopifyID;
  partData;

  constructor(partName, variantName, imgView1, imgView2, imgView3, order, partShopifyID) {
    this.partName = partName;
    this.variantName = variantName;
    this.imgView1 = imgView1;
    this.imgView2 = imgView2;
    this.imgView3 = imgView3;
    this.order = order;
    this.partShopifyID = partShopifyID;
  }
}
class VLTChart extends HTMLElement {
  productPageManager;
  dataRender = {};

  constructor() {
    super();
    this.productPageManager = document.getElementById("product-page-content");
    this.init();
    this.listentEventPartValueChanged();
  }
  init() {
    // console.log("lens", window.lens);
    if (!window.lens || Object.keys(window.lens).length == 0) {
      this.parentNode.remove();
    } else {
      this.parentNode.style.display = "block"
    }
    // console.log("product_option_selected", window.product_option_selected);
    this.partData = this.productPageManager.getPartData();
    this.initPart();
    this.renderPreview();

    // this.getLensByGroup()
    this.renderChart();
    this.renderDiscontinuedButton();

    // console.log("VLTChart", this.partData);
  }
  renderChart() {
    var x_values = $(this).data('chart-x');
    var y_values = $(this).data('chart-y');
    // converting comma separated string to array
    var x_vals_array = x_values.split(',');
    var y_vals_array = y_values.split(',');


    // chart options config
    var options = {
      type: 'line',
      data: {
        labels: x_vals_array,
        datasets: [{
          label: '',
          data: y_vals_array,
          fill: false,
          lineTension: 0.4,
          borderColor: '#d2ff02',
          borderWidth: 2,
          pointRadius: 0,
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false,
            labels: {
              color: 'rgb(255, 99, 132)'
            }
          },
          tooltip: {
            enabled: false,
            displayColors: false,
            usePointStyle: true,
          }
        },
        scales: {
          y: {
            min: 0,
            max: 100,
          },
          x: {
            ticks: {
              display: false
            }
          }
        }
      }
    }

   if (window.myChart) {
      window.myChart.destroy();
    }

    if (document.getElementById('chartJSContainer')) {
      var ctx = document.getElementById('chartJSContainer').getContext('2d');
      window.myChart = new Chart(ctx, options);
    }

  }
  initPart() {
    const urlParams = new URLSearchParams(window.location.search);
    let parts = urlParams.get("parts").split(",");
    for (let index = 0; index < this.partData.length; index++) {
      const element = this.partData[index];
      let isSelectDefault = true;
      let selectedVal = element.partValues[0];
      var matchItem = element.partValues.find(el => parts.includes(el.partValue));
      if (matchItem) {
        isSelectDefault = false;
        selectedVal = matchItem;
      }
      const { partValue, order, view1, view2, view3, partID } = selectedVal;
      this.setActivePart(element.partName, partValue);
      this.setPartValue(element.partName, partValue, view1, view2, view3, order, partID)

    }
  }
  activePartName
  activePartValue
  setActivePart(partName, partValue) {
    this.activePartName = partName;
    this.activePartValue = partValue;
    const EL_INPUT = document.getElementById("btn-part-value-" + partName + "-" + partValue + "-is_vlt");

    if (EL_INPUT) {
      var input_name = document.getElementById("btn-part-value-" + partName + "-" + partValue + "-is_vlt").getAttribute('name');
      document.getElementsByName(input_name).forEach(el => el.removeAttribute('checked'));
      EL_INPUT.setAttribute("checked", "true");
      EL_INPUT.click()
    }
  }
  renderDiscontinuedButton() {
    const discontinued_lens = window.discontinued_lens;
    // $(".xviz-lens").html('');
    for (const key in discontinued_lens) {
      if (Object.hasOwnProperty.call(discontinued_lens, key)) {
        var id = key.replaceAll(':', '').replaceAll('/', '');
        if ($('.weather-lens #' + id).length) {
          continue;
        }
        const element = discontinued_lens[key];
        // console.log(element, 'abchu')
        var toShown = "#standard-lens";
        // console.log(element.xviz, 'element.xviz')
        if (element.xviz == "Yes") {
          toShown = "#xviz-lens";
          $("#xviz-lens").css("display", "block");
        }
        var htmlAdded = element.is_polarized ? `
            <label id="${id}"
            >
              <input
                class="attr_selection"
                type="radio"
                value="${element.name}"
                name="${element.parent.name}-is_vlt"
              >
              <img
                src="${element.button_image}"
              >
              <span class="polarized_icon p_white"
                ><img
                  src="{{'polarized_p.png' | asset_url }}"
              ></span>
            </label>
            ` : `
            <label id="${key}"
            >
              <input
                class="attr_selection"
                type="radio"
                value="${element.name}"
                name="${element.parent.name}-is_vlt"
              >
              <img
                src="${element.button_image}"
              >
            </label>
            `
        $(toShown).find(".weather-lens").append(htmlAdded)
        var _this = this;

        document.getElementById(id).onclick = function () {
          _this.renderDiscontinuedPreview(id, element);
        }
        var els = document.getElementsByName(element.parent.name + "-is_vlt");
        // console.log(els, 'hu')
      }
    }
  }
  renderDiscontinuedPreview(key, element) {
    // console.log('renderDiscontinuedPreview', element,$(`input[name="${element.parent.name}-is_vlt"]`))
    this.setPreviewValue(element);
    this.renderChart();
    var _this = this;
    $(`input[name="${element.parent.name}-is_vlt"]`).closest('label').on('click', function () {
      if ($(this).attr('id') != key) {
        $(document.getElementById(key).getElementsByTagName('input')[0]).prop('checked', false);
        document.getElementById(key).getElementsByTagName('input')[0].removeAttribute('checked');
        $(this).find('input').prop('checked', true);

        _this.renderPreview();
        _this.renderChart();
      }
    })
  }
  getLensByGroup() {
    const lens = window.lens;

    var groupExist = {}
    var groups = []
    for (const key in lens) {
      if (Object.hasOwnProperty.call(lens, key)) {
        const element = lens[key];

        const { parent, chart, code, contrast, lens_category, lens_type, material, name, vlt_percentage, weather_condition, xviz } = lens[key];
        const group = parent;
        group.values = [element];
        groups.push(group);
        if (groupExist[parent.name]) groupExist[parent.name];
      }
    }
  }

  setPartValue(part, partvalue, view1, view2, view3, _order, partShopifyID) {
    this.setPart(part, partvalue, view1, view2, view3, _order, partShopifyID);
  }
  // setPartValue(currentPart) {
  //     this.setPart(currentPart.part, currentPart.partvalue, currentPart.view1, currentPart.view2, currentPart.view3, currentPart._order, currentPart.partShopifyID);
  // }
  setPart(partName, partvalue, imgView1, imgView2, imgView3, order, partShopifyID) {
    this.dataRender[partName] = new DataRenderToImage(partName, partvalue, imgView1, imgView2, imgView3, order, partShopifyID)
  }
  renderPreview() {
   
    var keys = Object.keys(this.dataRender || {});
    const lens = Object.values(window.lens || {});
    const partMapWIthLens = {}
    for (let index = 0; index < lens.length; index++) {
      const element = lens[index];
      if (element && element.partShopifyID) {
        partMapWIthLens[element.partShopifyID] = element;
      }
    }

    // let isLen = lens.find(el=>{
    //   if(el.parent){
    //     return el.parent.partShopifyID == 
    //   }
    //   return false;
    // })

    //console.log("renderPreview", this.dataRender, this.activePartName, this.activePartValue, lens, partMapWIthLens);
    let isNeedResetChart = true

    for (let index = 0; index < keys.length; index++) {
      var value = this.dataRender[keys[index]];
      let isLen = partMapWIthLens[value.partShopifyID]
      //console.log("renderPreview1", isLen, value.partShopifyID, value);
      if (index == 0) {
        if (document.getElementById('preview_frame')) {
          document.getElementById('preview_frame').src = value.imgView1;
        } else {
          let imgClass = isLen ? "layer-lens" : "layer-frame"
          $('#len_preview__container').prepend(`
            <img
              class="layer ${imgClass}"
              src="`+ value.imgView1 + `"
              id="preview_frame"
            >
            `)
        }
      }
      else if (isLen) {
        if (document.getElementById('preview_lens')) {
          document.getElementById('preview_lens').src = value.imgView1;
        } else {
          let imgClass = isLen ? "layer-lens" : "layer-frame"

          $(`
            <img
              class="layer ${imgClass}"
              src="`+ value.imgView1 + `"
              id="preview_lens"
            >
            `).insertAfter("#len_preview__container #preview_frame")
        }
        if (document.getElementById('popup_lens')) {
          document.getElementById('popup_lens').src = value.imgView1;
        }
        else {
          $('.image_comparison_popup .title-wrapper').prepend(`
            <img
              class="detailed-lens"
              id="popup_lens"
              src="`+ value.imgView1 + `"
            >
            `);
        }
      }

      if (partMapWIthLens[value.partShopifyID]) {
        this.setPreviewValue(partMapWIthLens[value.partShopifyID]);
        this.updateCompareLens(partMapWIthLens[value.partShopifyID]);
        isNeedResetChart = false;
      }

    }
    if (isNeedResetChart) {
      $(this).data('chart-x', '');
      $(this).data('chart-y', '');
    }
  }
  setPreviewLensImage(img) {

  }
  setPreviewValue(element) {
    let name = element.display_name || element.name
    document.getElementById('lens_proper_name').innerHTML = name || '';
    document.getElementById('lens_proper_code').innerHTML = element.code || '';

    if (element.vlt_percentage) {
      document.getElementById('vlt_val_wrapper').style.display = null
      document.getElementById('vlt_val').innerHTML = element.vlt_percentage + '%';
    } else {
      document.getElementById('vlt_val_wrapper').style.display = "none"
    }

    document.getElementById('lens_category_val').innerHTML = element.lens_category || 'N/A';
    document.getElementById('material_val').innerHTML = element.material || 'N/A';
    document.getElementById('lens_type_val').innerHTML = element.lens_type || 'N/A';

    if (element.weather_condition) {
      document.getElementById('light_cond_val').innerHTML = `<img src="` + element.weather_condition[0].image + `">`;
      document.getElementById('mobile_light_condition').innerHTML = `<img src="` + element.weather_condition[0].image + `">`;

      document.getElementById('light_cond_val_wrapper').style.display = null
    } else {
      document.getElementById('light_cond_val_wrapper').style.display = "none"
    }

    document.getElementById('mobile_lens_title').innerHTML = element.display_name || element.name;
    document.getElementById('mobile_lens_code').innerHTML = element.code || 'N/A';
    document.getElementById('mobile_lens_color').innerHTML = element.color || 'N/A';
    document.getElementById('mobile_vlt_percentage').innerHTML = element.vlt_percentage + '%';
    document.getElementById('mobile_contrast').innerHTML = element.contrast || 'N/A';
    document.getElementById('mobile_material').innerHTML = element.material || 'N/A';
    document.getElementById('mobile_lens_type').innerHTML = element.lens_type || 'N/A';
    document.getElementById('mobile_lens_code_below').innerHTML = element.code || 'N/A';

    if (element.chart) {
      // console.log($(this).data('chart-x'), 'this')
      $(this).data('chart-x', '');
      $(this).data('chart-y', '');

      const chart_value = element.chart.chart_value || [];
      const chart_length = chart_value.length;
      var dataX = '';
      var dataY = '';
      for (var i = 0; i < chart_length; i++) {
        var data = chart_value[i].split(' ');
        dataX += i == chart_length - 1 ? data[0] : data[0] + ',';
        dataY += i == chart_length - 1 ? data[1] : data[1] + ',';
      }
      if (chart_length == 0) {
        if (element.chart.values_x) {
          dataX = element.chart.values_x
        }
        if (element.chart.values_y) {
          dataY = element.chart.values_y
        }
      }

      $(this).data('chart-x', dataX);
      $(this).data('chart-y', dataY);
    } else {
      $(this).data('chart-x', '');
      $(this).data('chart-y', '');
    }
  }
  
  updateCompareLens(lens) {
    //console.log(lens.compare_after, 'linhhhuhu')
    if (lens.compare_after && lens.compare_before) {
      $('.try-now-wrapper').css({ "opacity": "1", "cursor": "pointer" })
      $('.try-now-wrapper').find('.try_now_text').css({ "opacity": "1" })
      $('image-compare').html(`
          <img slot="image-1" src="`+ lens.compare_before + `">
          <img slot="image-2" src="`+ lens.compare_after + `">
        `)
    } else {
      $('.try-now-wrapper').css({ "opacity": "1", "cursor": "default" })
      $('.try-now-wrapper').find('.try_now_text').css({ "opacity": "0.4" })
      $('image-compare').html('');
    }
  }
  
  listentEventPartValueChanged() {
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productPartChange, (event) => {
      const { part, partvalue, view1, view2, view3, order, partShopifyId } = event.data;
      //console.log("listentEventPartValueChanged", event.data);
      let _order = 0;
      this.setPartValue(part, partvalue, view1, view2, view3, _order, partShopifyId);
      this.setActivePart(part, partvalue);
      this.renderPreview();
      this.renderChart();

    });
  }
  removeListennerEvents() {
    this.variantChangeUnsubscriber();
  }
  connectedCallback() {
  }

  disconnectedCallback() {
    this.removeListennerEvents();
  }
}
if (!customElements.get('product-vlt-chart')) {
  customElements.define(
    'product-vlt-chart', VLTChart)
}